import { useSurveyByIdQuery } from '../data-access';

export const useSurveyById = (surveyId: string) => {
	const {
		data: surveyData,
		error: surveyError,
		isError: isSurveyError,
		isLoading: isSurveyLoading,
		refetch: refetchSurvey
	} = useSurveyByIdQuery(surveyId);

	return { isSurveyError, isSurveyLoading, refetchSurvey, surveyData, surveyError };
};
